type IconProps = {
  className?: string;
};

export function BackArrowIcon({ className }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M3.89941 12H19.8994"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.8994 18L3.89941 12L9.8994 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronRightIcon({ className }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M6 3L13.2218 9.77046C13.6432 10.1655 13.6432 10.8345 13.2218 11.2295L6 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SearchIcon({ className }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14L11.1333 11.1333"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CopyIcon({ className }: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M11.6667 4.66667H5.83333C5.189 4.66667 4.66667 5.189 4.66667 5.83333V11.6667C4.66667 12.311 5.189 12.8333 5.83333 12.8333H11.6667C12.311 12.8333 12.8333 12.311 12.8333 11.6667V5.83333C12.8333 5.189 12.311 4.66667 11.6667 4.66667Z"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33333 9.33333C1.69167 9.33333 1.16667 8.80833 1.16667 8.16667V2.33333C1.16667 1.69167 1.69167 1.16667 2.33333 1.16667H8.16667C8.80833 1.16667 9.33333 1.69167 9.33333 2.33333"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SelectChevronIcon({ className }: IconProps) {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M2.4 1.2L5.28873 3.90819C5.4573 4.06621 5.4573 4.33379 5.28873 4.49182L2.4 7.2"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ZapBadgeIcon({ className }: IconProps) {
  return (
    <div
      className={`relative size-10 shrink-0 rounded-full bg-emerald-50 dark:bg-primary/10 ${className ?? ''}`}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className="absolute top-1/2 left-1/2 size-6 -translate-x-1/2 -translate-y-1/2 text-emerald-600 dark:text-primary"
        aria-hidden
      >
        <path
          d="M15.5 2H8L5 13.5H9L7 22L20 8H14L15.5 2Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 5.5L9.5 9.5"
          className="stroke-white dark:stroke-primary-foreground"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

export function DollarBadgeIcon({ className }: IconProps) {
  return (
    <div
      className={`relative size-10 shrink-0 rounded-full bg-emerald-50 dark:bg-primary/10 ${className ?? ''}`}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className="absolute top-1/2 left-1/2 size-6 -translate-x-1/2 -translate-y-1/2 text-emerald-600 dark:text-primary"
        aria-hidden
      >
        <path
          d="M2 7C2 6.4477 2.44771 6 3 6H21C21.5523 6 22 6.4477 22 7V20C22 20.5523 21.5523 21 21 21H3C2.44771 21 2 20.5523 2 20V7Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M4 3H20"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g transform="translate(7.48 5)" className="stroke-white dark:stroke-primary-foreground" fill="none">
          <path d="M4.5454 1V13" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M8 3C8 3 5.07476 3 3.625 3C2.17524 3 1 3.89542 1 5C1 6.10458 2.17524 7 3.625 7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.04543 11.0908C2.04543 11.0908 4.55278 11.0908 5.79543 11.0908C7.03808 11.0908 8.04543 10.1954 8.04543 9.09082C8.04543 7.98624 7.03808 7.09082 5.79543 7.09082H3.79543"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </div>
  );
}

export function ApiDocsGraphic({ className }: IconProps) {
  return (
    <svg
      width="79"
      height="80"
      viewBox="0 0 79 80"
      fill="none"
      className={className}
      aria-hidden
    >
      <rect
        x="22.3693"
        y="30.634"
        width="11.5573"
        height="48.8031"
        rx="5.43957"
        transform="rotate(27.2814 22.3693 30.634)"
        className="fill-emerald-600 dark:fill-primary"
      />
      <path
        d="M38.8582 79.5029C35.4248 79.5029 32.6415 76.7196 32.6415 73.2863V24.4512C32.6415 21.0178 35.4248 18.2346 38.8582 18.2346H49.0358C52.4692 18.2346 55.2525 21.0178 55.2525 24.4512V73.2863C55.2525 76.7196 52.4692 79.5029 49.0358 79.5029H38.8582Z"
        className="fill-emerald-600 dark:fill-primary"
      />
      <path
        d="M47.2297 35.4249V63.0427C47.2297 65.2855 45.7601 67.1038 43.9475 67.1038C42.1348 67.1038 40.6652 65.2855 40.6652 63.0427V35.4249C40.6652 33.1822 42.1348 31.3639 43.9475 31.3639C45.7601 31.3639 47.2297 33.1822 47.2297 35.4249Z"
        className="fill-slate-50 dark:fill-[#141517]"
      />
      <rect
        x="61.7283"
        y="0.388541"
        width="16.1118"
        height="79.2229"
        rx="5.05103"
        className="fill-emerald-600/20 stroke-emerald-600 dark:fill-primary/20 dark:stroke-primary"
        strokeWidth="0.777081"
      />
      <rect
        x="61.778"
        y="5.41979"
        width="16.3187"
        height="69.1602"
        rx="5.05103"
        className="fill-emerald-600 stroke-emerald-600 dark:fill-primary dark:stroke-primary"
        strokeWidth="0.777081"
      />
    </svg>
  );
}
